import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelsMain } from './modules/ui/Main';

const ParcelsPage = (
  <SuspensePage>
    <PagesParcelsMain />
  </SuspensePage>
);

export default ParcelsPage;
